import React from 'react';
import ReactDOM from 'react-dom';
import config from './config/config';
import './style/index.css';
import { Redirect, Route, Switch, HashRouter as Router } from 'react-router-dom';
import Login from './components/Login';
import AddTxn from './components/AddTxn';
import Charts from './components/Charts';
import ViewTxns from './components/ViewTxns';
import History from './components/History';
import NTWRTH from './components/NTWRTH';
import NetWorthProjection from './components/NetWorthProjection';
import Footer from './components/Footer';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import store from './redux/store';

const routing = (
  <Router>
    <div className="index-wholeAppContainer">
      <div className="index-maxWidthContainer">
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
        <link href="https://fonts.googleapis.com/css2?family=Kanit:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap" rel="stylesheet" />
        <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap" />

        {!(localStorage.getItem(config.authTokenKey)) ? <Redirect to='/login' /> : null}

        <Provider store={store}>
          
          <Switch>
            <Route path="/login" component={Login} />
            <Route path="/viewTxns" component={ViewTxns} />
            <Route path="/charts" component={Charts} />
            <Route path="/history" component={History} />
            <Route path="/ntwrth/projection" component={NetWorthProjection} />
            <Route exact path="/ntwrth" component={NTWRTH} />
            <Route path="/" component={AddTxn} />
          </Switch>
        
          <Footer />
            
        </Provider>

      </div>
    </div>
  </Router>
);

ReactDOM.render(routing, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
